import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProductoService } from '../../../providers/producto.service';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import { FormBuilder, Validators, FormArray } from '@angular/forms';
import { TipoABM } from '../../../interfaces/tipo-abm';
import { TipoForm } from '../../../interfaces/tipo-form';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AccesorioService } from '../../../providers/accesorio.service';

@Component({
  selector: 'app-producto-ot',
  templateUrl: './producto-ot.component.html',
  styleUrls: ['./producto-ot.component.scss']
})
export class ProductoOtComponent implements OnInit {
  productos: any[] = [];
  TipoForm: TipoForm = new TipoForm();
  TipoABM: TipoABM = new TipoABM();
  tipoABM: string;
  tipoForm: string;
  titulo: string;
  cargando: boolean[];
  model: any;
  form = this._fb.group({
    id: [null],
    producto: [null, Validators.required],
    cantidad: [1, [Validators.required, Validators.min(1)]],
    accesorios: this._fb.array([]),
    especial: [false, Validators.required],
    producto_descripcion: [null],
    archivos: [null],
    CUT: [null],
  });
  @ViewChild('ngSelectProducto') private _ngSelectProducto: NgSelectComponent;

  get accesorios() {
    return (this.form.get('accesorios') as FormArray);
  }

  constructor(
    private _dialogRef: MatDialogRef<ProductoOtComponent>,
    private _productoSv: ProductoService,
    private _cmSv: ComunicacionService,
    @Inject(MAT_DIALOG_DATA) private _data,
    private _fb: FormBuilder,
    private _accesorioSv: AccesorioService,
  ) { }

  ngOnInit() {
    if (!this._data) {
      throw "La variable Input '_data' es requerida";
    }
    if (!this._data.tipoABM) {
      throw "La variable Input 'tipoABM' es requerida";
    }
    if (!this._data.model) {
      throw "La variable Input 'model' es requerida";
    }
    if (!this._data.titulo) {
      throw "La variable Input 'titulo' es requerida";
    }

    this._prepararForm();
  }

  private _prepararForm() {
    this.tipoABM = this._data.tipoABM;
    this.model = this._data.model;
    this.titulo = this._data.titulo;
    this.cargando = [];

    switch (this.tipoABM) {
      case this.TipoABM.ALTA:
        this._prepararAlta();
        break;
      case this.TipoABM.MODIFICACION:
        this._prepararModificacion();
        break;
    }

    // si cambia el selector de tipo de producto 
    this.form.controls.especial.valueChanges.subscribe(() => {
      // limpiar tanto el selector como el valor seleccionado
      this._ngSelectProducto.clearModel();
      // traer los productos que corresponden
      this._traerProductos();
    });

    // traer productos para el selector de productos
    this._traerProductos();
  }

  private _prepararAlta() {
    this.tipoForm = this.TipoForm.CREAR;
  }

  private _prepararModificacion() {
    this.tipoForm = this.TipoForm.EDITAR;
    this.form.get('id').setValue(this.model.id);
    this.form.get('especial').setValue(!!+this.model.producto.ProductoEspecial);
    this.form.get('especial').disable();
  }

  private _traerAccesorios() {
    if (this.form.controls.producto.value) {
      this.cargando.push(true);
      this._accesorioSv.getAccesorios({
        page: null,
        pageSize: null
      },
        {
          sort: 'descripcion',
          order: 'asc'
        },
        {
          IdTipoProducto: this.form.controls.producto.value.tipo.id
        }
      ).subscribe(
        (respuesta) => {
          this.cargando.pop();
          const data = this._cmSv.format(respuesta, false);
          if (data != this._cmSv.SIN_DATA) {
            this.form.controls.accesorios = this._fb.array(data.accesorios.map((accesorio) => {
              const group = this._fb.group({
                id: [accesorio.IdAccesorio],
                descripcion: [accesorio.descripcion],
                cantidad: [{
                  value: accesorio.cantidad,
                  disabled: true,
                }],
                seleccionado: [false]
              });
              // la cantidad se puede setear si el accesorio fue seleccionado
              group.get('seleccionado').valueChanges.subscribe((seleccionado) => {
                const cantidad_control = group.get('cantidad');
                cantidad_control.setValue(null);
                if (seleccionado) {
                  cantidad_control.enable();
                } else {
                  cantidad_control.disable();
                }
              });
              return group;
            }));
          }
        },
        () => {
          this.cargando.pop();
        }
      );
    }
  }

  private _traerProductos() {
    this.productos = [];
    this.cargando.push(true);
    this._productoSv.getProductos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        especial: this.form.controls.especial.value
      }
    ).subscribe(
      (respuesta) => {
        this.cargando.pop();
        const data = this._cmSv.format(respuesta, false);
        if (data != this._cmSv.SIN_DATA) {
          this.productos = data.productos;
        }
      },
      () => {
        this.cargando.pop();
      });
  }

  dismiss() {
    this._dialogRef.close();
  }

  // si cambia el selector de producto 
  ngSelectProductoChange(producto: any) {
    // set producto
    this.form.controls.producto.patchValue(producto);
    // clear accesorios (cambian según el accesorio, hay que volver a seleccionarlos)
    this.form.controls.accesorios = this._fb.array([]);
    // actualizar listado de accesorios
    this._traerAccesorios();
  }

  submit() {
    this.form.updateValueAndValidity();
    if (this.form.valid) {
      // la cantidad mínima por accesorio es 1
      this.form.get('accesorios').value
        .filter(
          (accesorio) => accesorio.seleccionado)
        .map(
          (accesorio) => {
            if (accesorio.cantidad < 1)
              accesorio.cantidad = 1;
            return accesorio;
          });
      this._dialogRef.close(this.form.value);
    }
  }
}